import axios from 'axios'

// Flask API
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_FLASK_URL + '/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  getTrails() {
    return apiClient.get('/trails')
  },
  getUser(username) {
    return apiClient.get(`/user/${username}`)
  }
}
